// extracted by mini-css-extract-plugin
export default {"titlegradient":"CustomTitle_titlegradient__5Lo7f"};